import {
  OMSMetricsRequestSchema,
  OMSMetricsResponseSchema,
} from "@redotech/redo-fulfillment-common/metrics";

export const getTotalLabelCost = {
  name: "getTotalLabelCost" as const,
  input: OMSMetricsRequestSchema,
  output: OMSMetricsResponseSchema,
};
